// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"a72d9a7ee94937e9bb7e","655":"64ad03c263055cea1e90"}[chunkId] + ".js";
};